import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-726290a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "selector" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "custom_selector_options"
}
const _hoisted_6 = { class: "tw-flex tw-gap-1" }
const _hoisted_7 = { class: "tw-text-sm tw-font-normal tw-leading-5 tw-text-[#0C0F4A]" }
const _hoisted_8 = { class: "tw-w-full" }

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Button from "@/core/components/ui/general/Button.vue";
import { ref, onMounted, computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectMaterialAssignPhaseModal',
  props: {
  assignPhases: {
    type: Array,
  },
  selectedAssignPhase: {
    type: Object,
  },
},
  emits: ["on-close", "on-save"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const props = __props;
const formValid = ref(false);
const isShowDropDown = ref(false);
const selectedPhaseId = ref(null) as any;
const selectedPhase = ref(null) as any;

const onCloseModal = () => {
  emits("on-close");
};
const onClickSelectBox = () => {
  isShowDropDown.value = !isShowDropDown.value;
};
const onSavePhases = () => {
  if (selectedPhaseId.value && formValid.value) {
    const payload = {
      assignPhaseId: selectedPhaseId.value,
    };
    emits("on-save", payload, selectedPhase.value);
  }
};

const onClickSelectPhase = () => {
  const checkedPhase = props.assignPhases?.find(
    (phase) => phase?.id === selectedPhaseId.value
  );
  selectedPhase.value = checkedPhase;
};

onMounted(() => {
  if (props.selectedAssignPhase) {
    selectedPhaseId.value = props.selectedAssignPhase.id;
    selectedPhase.value = props.selectedAssignPhase;
    formValid.value = true;
  } else {
    selectedPhase.value = null;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    width: "475px",
    class: "contract_assign_modal",
    onOnClose: onCloseModal,
    headerTitle: "Select phase to assign",
    headerDescription: "Select a phase to assign this item to that phase."
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!formValid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Please Select One Phase"))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "custom_selector_wrapper",
          onClick: onClickSelectBox
        }, [
          (!selectedPhase.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Select phase"))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(selectedPhase.value?.name), 1)),
          (!isShowDropDown.value)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 2,
                icon: "mdi-chevron-down"
              }))
            : _createCommentVNode("", true),
          (isShowDropDown.value)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 3,
                icon: "mdi-chevron-up"
              }))
            : _createCommentVNode("", true)
        ]),
        (isShowDropDown.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_v_form, {
                ref: "form",
                modelValue: formValid.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formValid).value = $event)),
                class: "tw-max-w-full tw-flex tw-flex-col tw-gap-6"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_v_radio_group, {
                      modelValue: selectedPhaseId.value,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((selectedPhaseId).value = $event)),
                        onClickSelectPhase
                      ],
                      placeholder: "Select of Phase",
                      rules: [(v) => !!v || 'Phase is required']
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.assignPhases, (phase, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "tw-flex tw-items-center tw-gap-1.5 tw-cursor-pointer",
                            key: phase?.id
                          }, [
                            _createVNode(_component_v_radio, {
                              class: "custom_radio",
                              value: phase?.id
                            }, null, 8, ["value"]),
                            _createElementVNode("span", _hoisted_7, " Phase " + _toDisplayString(index + 1) + " - " + _toDisplayString(phase?.name), 1)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "rules"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(Button, {
          label: "Save",
          onClick: onSavePhases,
          disabled: !formValid.value
        }, null, 8, ["disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})